import { useEffect } from 'react';
import { ACTION_SUBJECT, EVENT_TYPE } from '@atlaskit/editor-common/analytics';
import { fg } from '@atlaskit/platform-feature-flags';
// Temporary - track the usage of `dangerouslyAppendPlugins` which is deprecated
// Once `platform_editor_jira_base_composable` and `platform_editor_jira_polaris_composable` have
// fully rolled out in Jira this should trend to 0 and we can delete the deprecated prop.
export var useTrackDangerouslyAppendPlugins = function useTrackDangerouslyAppendPlugins(passedProps, handleAnalyticsEvent) {
  var _passedProps$dangerou5;
  useEffect(function () {
    var _passedProps$dangerou, _passedProps$dangerou2;
    if (((_passedProps$dangerou = passedProps === null || passedProps === void 0 || (_passedProps$dangerou2 = passedProps.dangerouslyAppendPlugins) === null || _passedProps$dangerou2 === void 0 ? void 0 : _passedProps$dangerou2.__plugins) !== null && _passedProps$dangerou !== void 0 ? _passedProps$dangerou : []).length > 0 && fg('platform_editor_track_dangerous_append_plugins')) {
      var _passedProps$dangerou3, _passedProps$dangerou4;
      handleAnalyticsEvent({
        payload: {
          // @ts-expect-error Temporary action - let's not extend the public analytics enum
          action: 'dangerousPluginAppended',
          actionSubject: ACTION_SUBJECT.EDITOR,
          eventType: EVENT_TYPE.TRACK,
          attributes: {
            count: passedProps === null || passedProps === void 0 || (_passedProps$dangerou3 = passedProps.dangerouslyAppendPlugins) === null || _passedProps$dangerou3 === void 0 ? void 0 : _passedProps$dangerou3.__plugins.length,
            names: passedProps === null || passedProps === void 0 || (_passedProps$dangerou4 = passedProps.dangerouslyAppendPlugins) === null || _passedProps$dangerou4 === void 0 ? void 0 : _passedProps$dangerou4.__plugins.map(function (plugin) {
              return plugin.name;
            })
          }
        }
      });
    }
  }, [handleAnalyticsEvent, passedProps === null || passedProps === void 0 || (_passedProps$dangerou5 = passedProps.dangerouslyAppendPlugins) === null || _passedProps$dangerou5 === void 0 ? void 0 : _passedProps$dangerou5.__plugins]);
};